import { icons, IconText } from '../../generic/Icon';

const SignInActionCard = () => (
  <div className="well well-small">
    <h4>
      <IconText icon={icons.github} text="Sign In" />
    </h4>
    <p>Access reports/attribution, dependency diffs, API data, and more...</p>
    <a className="btn btn-primary margin-right-sm" href="/auth/login">
      Login &raquo;
    </a>
    <a className="btn btn-link" href="/auth/register">
      Sign up
    </a>
  </div>
);

export default SignInActionCard;
